class CraftyArtGallery extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.dialog = this.querySelector('dialog');
    this.photos = [...this.querySelectorAll('[data-open-photo]')];
    this.visiblePhotos = this.photos;
    this.addEventListener('click', this.onClick, options);
    this.dialog.addEventListener('keydown', this.onKeyDown, options);
    this.dialog.addEventListener('close', () => this.lastPhoto?.focus(), options);
  }

  disconnectedCallback() {
    this.controller?.abort();
    if (this.dialog?.open) this.dialog.close();
  }

  onClick = (event) => {
    const photo = event.target.closest('[data-open-photo]');
    if (photo && this.dialog.showModal && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
      event.preventDefault();
      this.lastPhoto = photo;
      this.showPhoto(this.visiblePhotos.indexOf(photo));
      this.dialog.showModal();
      this.dialog.querySelector('[data-close]').focus();
    }
    if (event.target.closest('[data-close]')) this.dialog.close();
    if (event.target.closest('[data-previous]')) this.showPhoto(this.index - 1);
    if (event.target.closest('[data-next]')) this.showPhoto(this.index + 1);
  };

  showPhoto(index) {
    if (!this.visiblePhotos.length) return;
    this.index = (index + this.visiblePhotos.length) % this.visiblePhotos.length;
    const photo = this.visiblePhotos[this.index];
    const image = this.dialog.querySelector('[data-full-photo]');
    image.src = photo.href;
    image.alt = photo.dataset.alt;
    this.dialog.querySelector('[data-photo-title]').textContent = photo.dataset.title;
    this.dialog.querySelector('[data-photo-caption]').textContent = photo.dataset.caption;
    this.dialog.querySelector('[data-photo-position]').textContent = `${this.index + 1} / ${this.visiblePhotos.length}`;
    this.dialog.querySelectorAll('[data-previous], [data-next]').forEach(button => { button.hidden = this.visiblePhotos.length < 2; });
  }

  onKeyDown = (event) => {
    if (event.key === 'ArrowLeft') { event.preventDefault(); this.showPhoto(this.index - 1); }
    if (event.key === 'ArrowRight') { event.preventDefault(); this.showPhoto(this.index + 1); }
  };

}

if (!customElements.get('crafty-art-gallery')) customElements.define('crafty-art-gallery', CraftyArtGallery);
